export const feedbacks = [
  {
    id: 1,
    message:
      '1 khóa học xuất sắc, được đầu tư siêu bài bản, chi tiết đến từng dòng code cho đến anh mentor rất tâm huyết, giảng dạy những kiến thức từ chính kinh nghiệm đi làm thực tế, không ngại buồn ngủ để fix bug cùng học viên tới 12h đêm. Khóa học này chính là buớc ngoặt để bạn bước ra khỏi vùng an toàn model.fit, kích hoạt tiềm năng engineering ẩn sâu trong bản thân.',
    author: {
      username: 'Duong Nguyen',
      createAt: new Date(),
      company: 'FPT Smart Cloud',
      position: 'AI Engineer',
      experience: '2+ năm',
      course: 'FSDS K1',
      avatar: '/images/nguyen_tran_dang_duong.jpeg',
    },
    repository: {
      href: 'https://github.com/duongngyn0510/continuous-deployment-to-gke-cluster',
      start: 91,
      fork: 18,
      name: 'Continuous deployment text image retrieval service to Google Kubernetes Engine using CI/CD',
      image: `bg-[url('/images/architecture/1-nguyen_tran_dang_duong.png')]`,
    },
  },
  {
    id: 2,
    message:
      'Các module trong khoá học được đầu tư bài bản và chi tiết, giúp người học có thể áp dụng vào thực tế một cách dễ dàng. Anh Quân sẵn sàng giải đáp mọi thắc mắc. Bên cạnh đó, là những kinh nghiệm rất thực tế khó có thể tìm được từ các khoá học khác.',
    author: {
      username: 'Dung Hoang',
      createAt: new Date(),
      company: 'NamiTech JSC',
      position: 'AI Engineer',
      experience: '4+ năm',
      course: 'FSDS K1',
      avatar: '/images/dung_hoang.jpeg',
    },
    repository: {
      href: 'https://github.com/dunghoang369/feature-store',
      start: 56,
      fork: 10,
      name: 'Building a Feature Store System',
      image: `bg-[url('/images/architecture/2-dung_hoang.png')]`,
    },
  },
  {
    id: 3,
    message:
      'Một trong những khóa học theo cảm nhận của riêng mình là cần thiết cho các bạn muốn tìm hiểu về MLops mà không biết bắt đầu từ đâu . Ở khóa học này các bạn không chỉ được truyền đạt các kiến thức Machine Learning Engineer một cách chuyên sâu mà  mà còn cung cấp những kỹ năng quý báu trong cuộc sống và công việc, thật sự instructor rất nhiệt tình và quan tâm từng bạn học viên. Ngoài ra, nếu các bạn học và làm tốt thì còn có thể được instructor đi "sale" cho các sếp ở các công ty lớn luôn nhé. Ps: Các bạn cũng có thể được anh Wan định hướng công việc, review CV, tám dóc, tâm sự nỗi buồn thầm kín ... Thật sự đến với khóa học này, mình được nhận lại nhiều thứ hơn mình nghĩ ❤️',
    author: {
      username: 'Tien Nguyen',
      createAt: new Date(),
      company: 'Momo',
      position: 'ML Engineer',
      experience: '2+ năm',
      course: 'FSDS K1',
      avatar: '/images/tien_nguyen.jpeg',
    },
    repository: {
      href: 'https://github.com/TienNguyenKha/Diabetes-Prediction',
      start: 22,
      fork: 3,
      name: 'Building a Diabetes Prediction System',
      image: `bg-[url('/images/architecture/3-tien_nguyen.png')]`,
    },
  },
  {
    id: 4,
    message:
      'Khoá học hay và giúp ích cho việc triển khai 1 hệ thống ML lên production. Khoá học nặng về phần engineering nhưng được hướng dẫn rất kĩ. Highly recommend mọi người.',
    author: {
      username: 'Viet Khoa',
      createAt: new Date(),
      company: 'UC Irvine',
      position: 'Master, Data Science',
      experience: '4+ năm',
      course: 'FSDS K2',
      avatar: '/images/viet_khoa.jpeg',
    },
    repository: {
      href: 'https://github.com/eufouria/toxic-text-classification',
      start: 10,
      fork: 4,
      name: 'Build Toxic Text Classification App',
      image: `bg-[url('/images/architecture/4-viet_khoa.png')]`,
    },
  },
  {
    id: 5,
    message:
      'Cả 3 khoá học đều siêu chi tiết, cung cấp cho các ae 1 nền tảng siêu chắc chắn để bước vào thế giới MLOps. Giảng viên chuyên môn rất chắc và siêu nhiệt tình. Many tkss sếp Wan đẹp zaii !!!',
    author: {
      username: 'Long Pham',
      createAt: new Date(),
      company: 'Viettel',
      position: 'AI Engineer',
      experience: '2+ năm',
      course: 'FSDS K2',
      avatar: '/images/pham_khac_long.jpeg',
    },
    repository: {
      href: 'https://github.com/longphamkhac/IQA',
      start: 31,
      fork: 1,
      name: 'Building an Image Quality Assessment System',
      image: `bg-[url('/images/architecture/5-pham_khac_long.png')]`,
    },
  },
]

export type FeedbackType = (typeof feedbacks)[0]
